import Styles from 'components/WorkspaceDashboard/WorkspaceDashboard.module.scss'
import DesignerStyles from './DesignerDashboard.module.scss'
import { DesignerDashboardProps } from './Types'
import { DesignerHeader } from 'blaze-components/WorkspaceDashboardHeader/DesignerHeader'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { DESIGN_PATH, HOME_PATH } from 'paths'
import { WorkspaceDashboardSidebar } from 'blaze-components/WorkspaceDashboardSidebar/WorkspaceDashboardSidebar'
import { useSidebarState } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useSidebarState'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { useFocusWithin } from '@react-aria/interactions'
import SettingsContainer from 'components/Settings/SettingsContainer'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { DocRightPanelWrapper } from 'components/DocRightPanelWrapper/DocRightPanelWrapper'
import cx from 'classnames'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'
import { useOnboardingStrategiesEnabled } from 'flows/virtualMarketerOnboarding/steps'
import { MobileStopForStrategies } from 'components/MobileStop/MobileStopForStrategies'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'

const DesignerDashboard = observer(({ workspace, children }: DesignerDashboardProps) => {
  const fileId = useRouteMatch<{ key: string }>(DESIGN_PATH)?.params.key
  const sidebarState = useSidebarState()
  const { designStore } = useRootStore()
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isAPMobileWeb = useAPMobileWeb()
  const isOnboardingStrategiesEnabled = useOnboardingStrategiesEnabled()
  const { data: brandPlan } = useCurrentBrandPlan()

  const { focusWithinProps } = useFocusWithin({
    onFocusWithinChange(isFocused) {
      designStore?.editor.updateInstanceState({ isFocused })
    },
  })

  if (!fileId) {
    return <Redirect to={HOME_PATH} />
  }

  if (isAPMobileWeb && isOnboardingStrategiesEnabled && brandPlan?.has_content_strategies) {
    return <MobileStopForStrategies />
  }

  return (
    <div className={cx(Styles.dashboard, DesignerStyles.dashboard)} id="workspace-dashboard">
      {sidebarState.isVisible && <WorkspaceDashboardSidebar />}
      <div
        className={cx(Styles.innerContent, { [Styles.isDesignerDashboard]: isSystemRedesignEnabled })}
        {...focusWithinProps}
      >
        <DesignerHeader fileId={fileId} />
        {children}
        <SettingsContainer workspace={workspace} />
      </div>
      <ResponsiveDesign.Desktop>
        <DocRightPanelWrapper />
      </ResponsiveDesign.Desktop>
    </div>
  )
})

export { DesignerDashboard }
